<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="half"><span>UP</span></p>
<p class="half1"><span>THROUGH</span></p>
<p class="half2"><span>THE WATER</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half_title.vue?668441c2